require('./referralsInvitationsGiftFilter.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @Commons
const OKSelect = require('components/commons/OKSelect/OKSelect');

//@constants
const {
    REFERRALS_INVITATIONS_FILTER_GIFT_ALL
} = require('constants/index');

class ReferralsInvitationsGiftFilter extends React.Component {
    constructor(props) {
        super(props);
        const { immFilter } = this.props;

        this.state = {
            selected: immFilter.get('selected')
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleFilterChange(el) {
        const value = el.value;
        const selected = value === REFERRALS_INVITATIONS_FILTER_GIFT_ALL.toUpperCase() ? '' : value;
        this.props.onChangeSelected(selected);
        this.setState({
            selected
        });
    }

    buildSelectListOptions() {
        const { immGiftTypes } = this.props;
        const options = [{
            label: <FormattedText value="filterReferralsInvitationsGift-all" />,
            value: REFERRALS_INVITATIONS_FILTER_GIFT_ALL.toUpperCase()
        }];
        if(immGiftTypes.size > 0) {
            immGiftTypes.forEach(el => {
                options.push({
                    label: el,
                    value: el
                });
            });
        }
        return options;
    }

    render() {
        const selectedValue = this.state.selected || REFERRALS_INVITATIONS_FILTER_GIFT_ALL.toUpperCase();
        const selectListOptions = this.buildSelectListOptions();

        return (
            <div className="referrals-invitations-gift-filter">
                <h3 className="referrals-invitations-gift-filter__title">
                    <FormattedText value="filterReferralsInvitationsGift-type" />
                </h3>
                <div className="row">
                    <div className="col-xs-6">
                        <OKSelect
                            name="referrals-invitations-gift-status-dropdown"
                            onChange={this.handleFilterChange}
                            value={selectedValue}
                            options={selectListOptions}
                            searchable={false}
                            clearable={false}
                            openUp={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

ReferralsInvitationsGiftFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    immGiftTypes: PropTypes.object.isRequired,
    onChangeSelected: PropTypes.func
};

ReferralsInvitationsGiftFilter.defaultProps = {
    onChangeSelected: () => { }
};

module.exports = ReferralsInvitationsGiftFilter;
